import { useQuery } from 'react-query';

import { usePayoutsApi } from '../hooks/api';
import { minutesToMS } from '../utils/number-util';

import type { PayoutsResponse } from '../services/api/types';
import type { PayoutBalances } from '../types/payouts';
import { useOrganization } from '@context/OrganizationContext';
import { organizationKeys, vendorKeys } from '@config/queryKeys';
import { useVendor } from '@context/VendorContext';
export function usePayouts() {
  const api = usePayoutsApi();
  const { organizationId, organization } = useOrganization();

  const { data, isFetched, isFetching, isLoading, refetch } = useQuery<
    PayoutsResponse,
    unknown
  >(
    organizationKeys.payouts(organizationId),
    () => {
      return api.get({ organization: organizationId });
    },
    {
      enabled: !!organizationId,
      refetchInterval: minutesToMS(5),
    }
  );

  return {
    balances: data?.balances || ({} as PayoutBalances),
    instantPayoutsEnabled: data?.instantPayoutsEnabled,
    stripeAccountConnected: !!organization?.stripeAccountId,
    isFetched,
    isFetching,
    isLoading,
    payoutInterval: data?.payoutInterval,
    payouts: data?.results || [],
    refetch,
  };
}

export function useVendorPayouts() {
  const api = usePayoutsApi();
  const { vendorId, vendorOrganization } = useVendor();

  const { data, isFetched, isFetching, isLoading, refetch } = useQuery<
    PayoutsResponse,
    unknown
  >(
    vendorKeys.payouts(vendorId),
    () => {
      return api.get({ vendor: vendorId });
    },
    {
      enabled: !!vendorId,
      refetchInterval: minutesToMS(5),
    }
  );

  return {
    balances: data?.balances || ({} as PayoutBalances),
    instantPayoutsEnabled: data?.instantPayoutsEnabled,
    stripeAccountConnected: !!vendorOrganization?.stripeAccountId,
    isFetched,
    isFetching,
    isLoading,
    payoutInterval: data?.payoutInterval,
    payouts: data?.results || [],
    refetch,
  };
}
